import HeaderLogo from "./HeaderLogo.vue";
import ProgressBar from "./ProgressBar.vue";
import Question from "./Question.vue";
import TrackItem from "./TrackItem.vue";

export default {
    "HeaderLogo": HeaderLogo,
    "ProgressBar": ProgressBar,
    "Question": Question,
    "TrackItem": TrackItem
};
